export const baseContentInput = {
  name: 'content',
  type: 'richText',
  friendlyName: 'Conteúdo',
  defaultValue:
    '<p>Nullam semper, orci quis sagittis viverra, diam eros vehicula diam, in venenatis orci augue non odio. Praesent et sodales turpis.</p><p>Suspendisse id tortor urna. Ut vehicula leo nisi, ac condimentum ligula fringilla elementum. Vestibulum venenatis, orci vitae commodo pharetra, risus nunc sagittis arcu, ut dignissim leo lorem sit amet quam.</p>',
}
